module.exports = __webpack_public_path__ + "static/media/43.63cdb40c.mp3";